import React from 'react'
import {RichText} from 'prismic-reactjs';

const EnrollInstructions = ({ slice }) => {
    return (
        <section className="enroll-instructions">
            <div className="center-small">
                <div>
                <RichText render={slice.primary.instructions.raw} />
                </div>
            </div>
        </section>
    )
}

export default EnrollInstructions